//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The event model
* 
* @param bundledQuantity The count of items in the bundle
* @param isPersonalized Defines if the product is personalized
* @param productId The product id
* @param productTitle The localized title of the product
* @param description The localized description of the product
*/
@Serializable

data class BundledProduct (


      /* The count of items in the bundle */
    @SerialName(value = "bundledQuantity") @Required val bundledQuantity: kotlin.Int?,


      /* Defines if the product is personalized */
    @SerialName(value = "isPersonalized") @Required val isPersonalized: kotlin.Boolean,


      /* The product id */
    @SerialName(value = "productId") @Required val productId: kotlin.Int,


      /* The localized title of the product */
    @SerialName(value = "productTitle") @Required val productTitle: kotlin.String,


      /* The localized description of the product */
    @SerialName(value = "description") val description: kotlin.String? = null


) {




  }

